import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import { FaTimes, FaPlus } from "react-icons/fa";
import cn from "classnames";

import { Page } from "ui/components";
import CameraScreen from "./camera";

import { Manifest } from "services/action";
import { formatDate, UTCFormat } from "utilities/common";
// import { Input } from "ui/components";

const ManifestStart = ({ location }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state?.Form);
  const { manifest_id } = location?.state;

  const [data, setData] = React.useState(null);
  const [img, setImage] = React.useState([]);
  const [pos, setPos] = React.useState(null);
  const [show, setShow] = React.useState(false);
  // const [km, setKm] = React.useState();
  // const [option, setOption] = React.useState([]);

  const $onLoad = async (id) => {
    const req = await Dispatch(Manifest.$show(id));

    if (req?.message === "success") {
      if (req?.data !== null) {
        setData(req?.data);
      }
    }
  };

  const $removeImg = async (i) => {
    let newImg = [...img];
    newImg.splice(i, 1);
    setImage(newImg);
  };

  const $onStart = async (e) => {
    let payload = {
      atd_at: UTCFormat(
        formatDate(new Date(), "YYYY-MM-DD"),
        formatDate(new Date(), "HH:mm")
      ),
      images: img,
      latitude: pos?.lat,
      longitude: pos?.lng,
      // start_odo: km,
    };

    if (data?.status === "published") {
      const req = await Dispatch(Manifest.$accept(manifest_id, payload));
      if (req?.message === "success") {
        const req = await Dispatch(Manifest.$start(manifest_id, payload));
        if (req?.message === "success") {
          History.goBack();
        }
      }
    } else if (data?.status === "accepted") {
      const req = await Dispatch(Manifest.$start(manifest_id, payload));

      if (req?.message === "success") {
        History.goBack();
      }
    }
  };

  React.useEffect(() => {
    $onLoad(manifest_id);
  }, [manifest_id]);

  React.useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        setPos({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      },
      (error) => {
        // See error code charts below.
        console.log(error.code, error.message);
      },
      { enableHighAccuracy: true, timeout: 60000, maximumAge: Infinity }
    );
  }, []);

  return (
    <Page
      title="E-POD"
      backTo={() => History.goBack()}
      action={
        <div>
          <Button
            type="button"
            variant="success"
            className={cn(
              "pe-4 ps-4 rounded w-100",
              StateForm?.loading ? "btn-loading" : ""
            )}
            onClick={$onStart}
          >
            Simpan
          </Button>
        </div>
      }
    >
      <div className="px-2 py-3">
        <div className="row align-items-center justify-content-center ">
          {img?.map((d, i) => (
            <div
              key={i}
              className="position-relative col-4"
              style={{ height: 100, width: 100, margin: 5 }}
            >
              <div
                className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center bg-danger rounded-circle border border-2 border-white mt-n2 me-n1 rounded"
                style={{ height: 25, width: 25 }}
                onClick={() => $removeImg(i)}
              >
                <FaTimes color="#fff" />
              </div>
              <img
                src={d}
                alt=""
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "cover",
                  borderRadius: 5,
                }}
              />
            </div>
          ))}

          {StateForm?.loading ? (
            <div
              className="col-4 rounded bg-dark bg-opacity-25 d-flex flex-column align-items-center justify-content-center"
              style={{ height: 100, width: 80, margin: 5 }}
            >
              <div className="spinner-border text-blue" role="status"></div>
              <div>
                <small>uploading</small>
              </div>
            </div>
          ) : null}

          <div
            className="col-4 d-flex flex-column align-items-center justify-content-center"
            onClick={() => setShow(true)}
          >
            <div
              className={cn(
                "border-dashed rounded  d-flex flex-column align-items-center justify-content-center",
                StateForm?.errors?.images ? "border-danger" : "border-primary"
              )}
              style={{ height: 100, width: 80, margin: 5 }}
            >
              <FaPlus
                size={20}
                color={StateForm?.errors?.images ? "red" : "#2f83ba"}
              />
              <div>
                <small>ambil foto</small>
              </div>
            </div>

            {StateForm?.errors?.images ? (
              <div
                className="text-center"
                style={{ marginBottom: 5, marginTop: 10 }}
              >
                <span style={{ color: "red" }}>
                  {StateForm?.errors?.images}
                </span>
              </div>
            ) : null}
          </div>
        </div>

        {StateForm?.errors?.id ? (
          <div
            className="text-center"
            style={{ marginBottom: 5, marginTop: 10 }}
          >
            <span style={{ color: "red" }}>{StateForm?.errors?.id}</span>
          </div>
        ) : null}

        {/* {option?.length > 0 && (
          <div className="d-flex gap-1 flex-wrap">
            {option?.map((o, i) => (
              <div
                className="p-2 border border-primary rounded-3 bg-primary-lt fw-semibold"
                key={i}
              >
                {o}
              </div>
            ))}
          </div>
        )}

        {data?.moda?.land_freight?.vehicle?.id && (
          <div className="py-3">
            <div>KM Awal:</div>
            <div className="form-group ">
              <Input
                icon={<FaTruckMoving />}
                value={km}
                onChange={(e) => {
                  setKm(e.target.valueAsNumber);
                }}
                type="number"
                placeholder=""
                error={StateForm?.errors?.start_odo}
                lg
              />
            </div>
          </div>
        )} */}
      </div>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        backdrop="static"
        centered
        size="small"
        enforceFocus={true}
        fullscreen
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <CameraScreen
            setImg={setImage}
            numberImg={img?.length}
            onClose={() => setShow(false)}
            code={location?.state?.code}
            type="start"
            // setOption={(e) => setOption(e)}
          />
        </Modal.Body>
      </Modal>
    </Page>
  );
};

export default ManifestStart;
